/**
 * @version:               1.0.0
 * @createTime:            2021.10.08
 * @updateTime:            2021.10.08
 * @author:                zhangju
 * @description
 ***/
export default {
    name: 'content-table02',
    props: {
        tab: {
            type: String,
            default: ''
        },
        hideQuery: {
            type: Boolean,
            default: false
        },
        // 当前组件属于哪个模块
        activePage:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dataList:{
                dywz: '3',
                spnk: '4',
                bps: '5',
                sfjy: '6',
                sfjs: '7',
                flfg: '8',
                zdxwj: '9',
                ywfl: '10',
                gjxg: '11',
                ywzc: '12',
                ywpj: '13',
                gjgy: '14',
                zcjj: '15',
                alfx: '16',
                yjbg: '17'
            },
            active: '',
            path: '',
            query: {
                title: null,
                fbdw: null,
                ejlb: null,
                xwbt: null,
                fbrq: null,
                zcjg: null,
                fbfy: null,
                nf: ''
            },
            fbdwList: [],
            data: {
                offset: 0,
                limit: 10,
                total: null,
                data: null
            },
            yearList: []
        };
    },
    mounted() {
        this.init();
        // this.getFbdwList();
    },
    methods: {
        init() {
            this.handleSearch();
        },
        // 点击跳转详情
        handleToDetail(item) {
            this.active = 'flzy';
            const url = this.$router.resolve({path: '/lltt/dedail', query: {active: this.active, bh: item.bh, ejlb: item.ejlb}});
            window.open(url.href, '_blank');
        },
        // 查询
        handleSearch() {
            this.queryHsalPage();
        },
        // 重置
        handleReset() {
            this.query = {
                title: null,
                fbdw: null,
                ejlb: null,
                xwbt: null,
                fbrq: null,
                zcjg: null,
                fbfy: null
            };
            this.queryHsalPage();
        },
        pageInformation(pageInfo) {
            this.query.limit = pageInfo.limit;
            this.query.offset = pageInfo.offset;
            this.handleSearch();
        },
        searchButton() {
            this.query.limit = 10;
            this.query.offset = 0;
            this.handleSearch();
        },
        queryHsalPage() {
            this.query.ejlb = this.dataList[this.tab];
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.Hsal.HsalpageOut,
                params: this.query
            }).then((res) => {
                this.data = res.data;
            })
                .catch(() => {
                    Artery.notice.warning({
                        title: '失败',
                        desc: '查询列表失败！',
                        duration: 1
                    });
                });
        }
        // 获取发布单位列表
        // getFbdwList() {
        //     window.fdGlobal.ajax({
        //         method: window.fdConfig.methodGet,
        //         url: window.fdConfig.url.Hsal.fbdwList
        //     }).then((res) => {
        //         if (res.data) {
        //             this.fbdwList = res.data;
        //         }
        //     });
        // }
    }
};
